<template>
  <vuex-table :fields="fields" table_store="autoinformer/campaigns/tasks/table">
    <template slot="state" slot-scope="{ item }">
      <state-badge :value="item.state" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-control v-if="item.state === 'pending'" type="trash" @click="remove(item)" />
    </template>
  </vuex-table>
</template>

<script>
  import { TaskModalService } from '@autoinformer/modals/TaskModalService.js';
  import { mapActions, mapMutations } from 'vuex';
  import StateBadge from '@autoinformer/components/tasks-badge-status';

  export default {
    components: { StateBadge },
    computed: {
      fields() {
        return [
          { key: 'number', label: this.$t('autoinformer.task.field.number'), sortable: true },
          { key: 'state', label: this.$t('shared.component.table.field.status'), sortable: true },
          {
            key: 'attempts',
            label: this.$t('autoinformer.task.table.field.attempts'),
            sortable: true
          },
          {
            key: 'last_attempt',
            label: this.$t('autoinformer.task.table.field.last_attempt'),
            sortable: true
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true
          },
          {
            key: 'updated_at',
            label: this.$t('shared.component.table.field.updated_at'),
            sortable: true
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },
    created() {
      const campaign_id = this.$route.params.id;
      this.set_campaign_id(campaign_id);
    },
    methods: {
      ...mapMutations({
        set_campaign_id: 'autoinformer/campaigns/tasks/campaign_id'
      }),
      ...mapActions('autoinformer/campaigns/tasks/table', ['getAsyncData']),
      // create() {
      //   const campaign_id = this.$route.params.id;
      //   TaskModalService.create(campaign_id).on('success', () => this.getAsyncData());
      // },
      remove(item) {
        const campaign_id = this.$route.params.id;
        const task_id = item.id;
        TaskModalService.remove({ campaign_id, task_id }, item).on('success', () =>
          this.getAsyncData()
        );
      }
    }
  };
</script>
